export class FindAllResponse<T> {
  data: Array<T>;
  total: number;

  constructor(res: Partial<FindAllResponse<T>> = {}) {
    this.data = res.data ? res.data : [];
    this.total = res.total ? res.total : 0
  }
}
